/**
 * Detects whether a solution represents the sequential monadic concept test variant
 * by checking for `"sequential monadic"` in the normalized solution name.
 *
 * Aligned with `is-custom-solution.ts` in feature-guided-setup.
 */
const isSequentialMonadicSolution = <T extends { name?: string | null }>(
  solution?: T | null,
): boolean => {
  if (!solution?.name) return false;
  return solution.name.trim().toLowerCase().includes('sequential monadic');
};

export default isSequentialMonadicSolution;
